// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"8f5eb523","192":"d5011f3e","239":"3d59e136","455":"7bb56cd9","488":"26049365","977":"89ae4630"}[chunkId] + ".chunk.js";
};